import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-103">
      <div className="max-w-3xl mx-auto text-center" data-id="element-104">
        <div className="w-28 h-28 bg-gradient-to-br from-primary to-[#1E40AF] rounded-full mx-auto flex items-center justify-center text-5xl shadow-[0_0_30px_rgba(37,99,235,0.4)] mb-8 border-4 border-bg-dark relative" data-id="element-105">
          <div className="absolute inset-0 rounded-full border-2 border-white/20" data-id="element-106"></div>
          🍎
        </div>

        <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-8 tracking-tight" data-id="element-107">
          Acerca de EduLabs™ Matemática
        </h2>

        <div className="relative" data-id="element-108">
          <span className="absolute -top-6 -left-4 text-6xl text-primary/20 font-serif" data-id="element-109">
            "
          </span>
          <p className="text-text-main text-xl sm:text-2xl leading-relaxed italic font-medium relative z-10" data-id="element-110">
            Hemos volcado en este sistema los esquemas reales que usamos en aula
            para transformar la matemática de un tema temido en la materia
            favorita de los niños. Menos teoría aburrida, más práctica efectiva
            y visual.
          </p>
          <span className="absolute -bottom-10 -right-4 text-6xl text-primary/20 font-serif" data-id="element-111">
            "
          </span>
        </div>
      </div>
    </section>;
}